export class GetPackDetails
{
    private packToPriceTxtMap: Map<string, string>;

     constructor(packPriceTags: string)
            {
                console.log(" GetPackPriceTxt () invoked: "+packPriceTags);
        
                this.packToPriceTxtMap = new Map();
        
                this.setPackToPriceMap(this.getPackEntity(packPriceTags));

                return this;
            }
        
            public  getPrice(packName: string,  price: string): string
            {
                 let priceTxt: string | undefined = this.packToPriceTxtMap.get(packName);
        
                if(priceTxt !== undefined)
                {
                    return priceTxt.replace("$price$", price.toString());
                }
        
                return "";
            }
        
          getPackEntity( packPriceTags: string): string[]
            {
                return packPriceTags.split("|");
            }
        
            setPackToPriceMap( packEntities: string[])
            {
                packEntities.forEach((packEntity: string) =>
                {
                    let packToPrice: string[] = packEntity.split(",");
        
                    this.packToPriceTxtMap.set(packToPrice[0], packToPrice[1]);
                });
            }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/getpackdetails.ts